/** Slice 21c — Amazon buy list URL validation (Settings + Restock). */
export function isAmazonBuyListUrl(raw: string): boolean {
  return /^https?:\/\/\S+\.\S+/.test(raw.trim());
}
